<rask-page
  pageTitle="Viol3"
  noPadding>
  <ng-container headerContent>
    <div class="row">
      <rask-input class="col-2" label="Arbetsorder beteckning" [(ngModel)]="arbetsorderBeteckningSearchStr"></rask-input>
      <rask-button class="col-1 integation-search-button" color="secondary" (click)="sokArbetsorder()">Sök</rask-button>
      <rask-action-button class="col-1 vo-action-buttons" icon="fas fa-sync-alt" (click)="sync()" [disabled]="!canSync()">Synka</rask-action-button>
      <rask-action-button class="col-5 vo-action-buttons" icon="far fa-paper-plane" (click)="send()" [disabled]="!canSend()">Skicka</rask-action-button>
    </div>

    @if ((alerts$ | async).length > 0) {
      <div class="row">
        <rask-message-panel class="col-12 integration-messagebox"
          [numberOfItemsToDisplay]="5"
          [maxNumOfRows]="2"
          [items]="alerts$"
          >
        </rask-message-panel>
      </div>
    }
  </ng-container>
  <rask-tabs parameterName="section" layout="parent" class="h-100" aid="integration">
    <rask-tab label="Viol3 XML" routeId="xmlSection">
      <rask-viol3xml [selectedArbetsorder]="selectedArbetsorder"></rask-viol3xml>
    </rask-tab>
    <rask-tab label="historik" routeId="historySection">
      <rask-virkesorder-historik [selectedArbetsorder]="selectedArbetsorder"></rask-virkesorder-historik>
    </rask-tab>
    <rask-tab label="Granska virkesorder" routeId="previewSection">
      <rask-virkesorder-viol3-preview></rask-virkesorder-viol3-preview>
    </rask-tab>
    <rask-tab label="Leveranser" routeId="leveransSection">
      <rask-leveranser></rask-leveranser>
    </rask-tab>
    <rask-tab label="Inmätningstest" routeId="inmatningTest">
      <rask-inmatningtest></rask-inmatningtest>
    </rask-tab>
  </rask-tabs>
</rask-page>
